import * as React from "react";
import type { SVGProps } from "react";
const SvgLaundryRoomIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M5.04 1.68c-.921 0-1.68.759-1.68 1.68v21.28c0 .921.759 1.68 1.68 1.68h17.92c.921 0 1.68-.759 1.68-1.68V3.36c0-.921-.759-1.68-1.68-1.68zm0 1.12h17.92c.316 0 .56.244.56.56v21.28c0 .316-.244.56-.56.56H5.04a.55.55 0 0 1-.56-.56V3.36c0-.316.244-.56.56-.56m12.32 1.68a1.12 1.12 0 1 0 0 2.24 1.12 1.12 0 0 0 0-2.24m3.36 0a1.12 1.12 0 1 0 0 2.24 1.12 1.12 0 0 0 0-2.24M14 8.4c-3.59 0-6.525 2.835-6.703 6.383a.6.6 0 0 0-.01.216c-.001.04-.007.08-.007.12A6.73 6.73 0 0 0 14 21.84a6.73 6.73 0 0 0 6.72-6.72c0-.04-.006-.079-.007-.12a.6.6 0 0 0-.01-.22c-.177-3.474-3.012-6.23-6.504-6.339A.6.6 0 0 0 14 8.4m0 1.12a5.59 5.59 0 0 1 5.441 4.294 3.9 3.9 0 0 0-1.509-.373c-.8-.017-1.42.327-2.003.604s-1.142.515-1.929.515-1.346-.239-1.93-.515c-.583-.277-1.202-.62-2.001-.604h-.001c-.43.009-.955.12-1.51.373A5.59 5.59 0 0 1 14 9.52m-3.91 5.04h.002c.453-.01.887.207 1.499.496.61.29 1.386.624 2.409.624s1.799-.334 2.41-.623c.61-.29 1.045-.507 1.498-.497.364.008 1.03.173 1.689.636A5.59 5.59 0 0 1 14 20.72a5.59 5.59 0 0 1-5.597-5.523c.659-.464 1.325-.63 1.688-.637"
    />
  </svg>
);
export default SvgLaundryRoomIcon;
